import { useParams } from "react-router";
import { Id } from "@convex/_generated/dataModel";
import { ExpenseDetailPage } from "@/components/expenses/expense-detail-page";

export default function ExpensePage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <p className="text-muted-foreground">Expense not found</p>
      </div>
    );
  }

  const expenseId = id as Id<"expenses">;

  return <ExpenseDetailPage expenseId={expenseId} />;
}
